import AxiosAPI from '../../../../../utils/AxiosAPI';

export const handleAddressSaveOpe = (formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/customer-addresses`)
            .post(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    setIsError(data.referenceName);
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

export const handleAddressResetOpe = (customerId, addresstype) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/customer-addresses`)
            .patch({ customerId, addresstype })
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(Error(data.title));
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
export default null;
